import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { ValueType } from 'react-select';
import { serverOptions } from '../../stores/servers/selectors';
import { RootState } from '../../stores/store';

interface Props extends LocalizeContextProps {
    type: 'multi' | 'single';
    selected: string[] | string;
    servers: Array<{ label: string, value: string }>;
    selection?: ValueType<{ label: string, value: string }> | { label: string, value: string } | null;
    updateSelection: (selection: ValueType<{ label: string, value: string }> |
         { label: string, value: string }) => void;
}

class WorkspaceSelect extends React.Component<Props> {
    public componentDidMount() {
        if (this.props.type === 'multi') {
            this.props.updateSelection(
                this.props.servers.filter((server) =>
                    (this.props.selected as string[]).find((id) => server.value === id))
            );
        } else {
            this.props.updateSelection(this.props.servers.find((server) =>
                server.value === this.props.selected)!);
        }
    }

    public render() {
        const t = this.props.translate;
        return (
            <React.Fragment>
                <Select className={"dropdown-select server-select"}
                    isMulti={this.props.type === 'multi'}
                    options={this.props.servers}
                    value={this.props.selection}
                    onChange={this.handleSelectChange}
                />
            </React.Fragment>
        );
    }

    private handleSelectChange = (val?: ValueType<{ label: string, value: string }>) => {
        if (this.props.type === 'multi') {
            this.props.updateSelection((val === null || val === undefined) ? [] : val);
        } else {
            if (val === null || val === undefined) { return; }
            // tslint:disable-next-line:no-any
            this.props.updateSelection(val as any);
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    servers: serverOptions(state),
});

export default connect(mapStateToProps)(withLocalize(WorkspaceSelect));